// Flight-set ghost tracks (Plan 13). Pure layer builder — receives plain
// {flightId, name, latlngs} objects (fetched + decimated in web/), returns
// Leaflet polylines that the caller adds to the map. Kept separate from
// viewer.js so it is unit-testable and the HDD shell (which passes no set
// data) pulls in nothing extra.
//
// Each ghost is a CASED PAIR of polylines — a wide dark under-stroke below a
// near-white top stroke — because a single thin grey line disappears into
// satellite imagery (operator feedback 2026-09-01). The flat return array is
// ordered [casing, top] per ghost; viewer.js restores that stacking with a
// reverse bringToBack sweep when mounting.

export const GHOST_CASING_STYLE = {
  color: "#16181d",
  weight: 6,
  opacity: 0.8,
  interactive: true,
};

export const GHOST_STYLE = {
  color: "#e8eaed",
  weight: 3,
  opacity: 0.9,
  interactive: true,
};

// Build (but do NOT add to the map) a [casing, top] polyline pair per ghost.
// Tooltip and click are bound to BOTH strokes — the wide casing doubles as a
// generous hit target.
export function buildGhostLayers(L, ghostTracks, onClick) {
  const layers = [];
  for (const g of ghostTracks || []) {
    if (!g || !Array.isArray(g.latlngs) || g.latlngs.length < 2) continue;
    for (const style of [GHOST_CASING_STYLE, GHOST_STYLE]) {
      const line = L.polyline(g.latlngs, { ...style });
      if (typeof g.name === "string" && g.name.length > 0) {
        line.bindTooltip(g.name, { sticky: true });
      }
      if (typeof onClick === "function") {
        line.on("click", () => onClick(g.flightId));
      }
      layers.push(line);
    }
  }
  return layers;
}
